/* tslint:disable */
/* eslint-disable */
/**
 * WeighMed Backend APIs - OpenAPI 3.0
 * You can find out more about Swagger at [https://editor.swagger.io/](https://editor.swagger.io/).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VQueryNotificationsRequestParams
 */
export interface VQueryNotificationsRequestParams {
    /**
     * Get notifications by clinic Id
     * @type {string}
     * @memberof VQueryNotificationsRequestParams
     */
    clinicId?: string;
    /**
     * Get notifications by tank Id
     * @type {string}
     * @memberof VQueryNotificationsRequestParams
     */
    tankId?: string;
    /**
     * Get notifications by caddy Id
     * @type {string}
     * @memberof VQueryNotificationsRequestParams
     */
    caddyId?: string;
}

/**
 * Check if a given object implements the VQueryNotificationsRequestParams interface.
 */
export function instanceOfVQueryNotificationsRequestParams(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VQueryNotificationsRequestParamsFromJSON(json: any): VQueryNotificationsRequestParams {
    return VQueryNotificationsRequestParamsFromJSONTyped(json, false);
}

export function VQueryNotificationsRequestParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): VQueryNotificationsRequestParams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clinicId': !exists(json, 'clinicId') ? undefined : json['clinicId'],
        'tankId': !exists(json, 'tankId') ? undefined : json['tankId'],
        'caddyId': !exists(json, 'caddyId') ? undefined : json['caddyId'],
    };
}

export function VQueryNotificationsRequestParamsToJSON(value?: VQueryNotificationsRequestParams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'clinicId': value.clinicId,
        'tankId': value.tankId,
        'caddyId': value.caddyId,
    };
}

